var _process$env$REACT_AP, _process$env$REACT_AP2;
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { markHostStyles } from './utils/styleIsolation';
var root = createRoot(document.getElementById('root'));
var scriptCookie = document.createElement('script');
scriptCookie.src = (_process$env$REACT_AP = process.env.REACT_APP_https://cdn.cookielaw.org/scripttemplates/otSDKStub.js) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : '';
scriptCookie.type = 'text/javascript';
scriptCookie.setAttribute('charset', 'UTF-8');
scriptCookie.setAttribute('data-domain-script', (_process$env$REACT_AP2 = process.env.REACT_APP_019bfeda-8654-7be8-9928-d5fe9907f4ee-test) !== null && _process$env$REACT_AP2 !== void 0 ? _process$env$REACT_AP2 : '');
scriptCookie.async = true;
document.head.appendChild(scriptCookie);
// Mark all existing styles as belonging to the host app
// This prevents them from being scoped when remote apps load
markHostStyles();
root.render(/*#__PURE__*/ React.createElement(BrowserRouter, null, /*#__PURE__*/ React.createElement(App, null)));
